import React from 'react';
import $ from 'jquery';
import fetch from 'utils/fetch';

export const renderCaseCustomer = ({ rowData }) => {
  return (
    <div>
      <strong>{rowData.customer}</strong>
      <br /> {rowData.customer_case}
    </div>
  );
};

export const renderAmount = ({ cellData }) => {
  if (cellData && Number.isFinite(cellData)) {
    return Number.parseFloat(cellData)
      .toFixed(2)
      .replace('.', ',');
  }

  return '0,00';
};

export const onTargetClickAction = ($target, id, errorMessage) => {
  const action = $target.attr('data-action');
  const method = $target.attr('data-method');
  const data = [id];

  fetch(action, {
    method: method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(
    res => window.location.replace(res.url),
    err => {
      console.log(errorMessage, err);
    }
  );
};

export const onClickAction = (evt, id, errorMessage) => {
  evt.stopPropagation();

  const $button = $(evt.currentTarget);
  const action = $button.attr('data-action');
  const method = $button.attr('data-method');
  const data = [id];

  fetch(action, {
    method: method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(
    res => window.location.replace(res.url),
    err => {
      console.log(errorMessage, err);
    }
  );
};



// WEBPACK FOOTER //
// ./src/modules/saas/common/columns.js